/**
 * Одиниці складу матеріалу: канонічні значення в UI та БД — «м» | «шт» | «кг».
 * Латинські m / pcs / kg зі старих записів нормалізуються при відкритті форми.
 */

export const MATERIAL_UNIT_SELECT_CODES = ["м", "шт", "кг"];

/**
 * Повертає канонічне значення для select або null, якщо одиниця довільна.
 */
export function normalizeMaterialUnitToCode(raw) {
    if (raw == null || String(raw).trim() === "") {
        return "м";
    }
    const s = String(raw).trim();
    const lower = s.toLowerCase();
    // Латиниця (legacy)
    if (lower === "m" || lower === "pcs" || lower === "kg") {
        if (lower === "m") {
            return "м";
        }
        if (lower === "pcs") {
            return "шт";
        }
        return "кг";
    }
    if (lower === "кг" || lower === "кг.") {
        return "кг";
    }
    if (
        lower === "м" ||
        lower === "м." ||
        lower === "метр" ||
        lower === "метри" ||
        lower === "метра" ||
        lower === "п.м." ||
        lower === "п.м" ||
        lower === "пог.м" ||
        lower === "пог. м" ||
        lower === "пог м"
    ) {
        return "м";
    }
    if (
        lower === "шт" ||
        lower === "шт." ||
        lower === "штука" ||
        lower === "штуки"
    ) {
        return "шт";
    }
    return null;
}

/** Значення для Form.Select: збігається з одним з option value. */
export function materialUnitSelectValue(raw) {
    const c = normalizeMaterialUnitToCode(raw);
    if (c != null) {
        return c;
    }
    return String(raw).trim();
}

export function isStandardMaterialUnitSelectValue(v) {
    return MATERIAL_UNIT_SELECT_CODES.includes(String(v ?? "").trim());
}

/** Од. на кшталт «упаковок», «пачка» — для дефолту нової фурнітури беремо «шт», поки користувач не змінить. */
export function isPackagingLikeMaterialUnit(raw) {
    const s = String(raw ?? "").trim().toLowerCase();
    if (!s) return false;
    if (/^(упак|пачк|pack)/.test(s)) return true;
    return s.includes("упаков");
}

/** Одиниця за замовчуванням у формі «Новий матеріал» залежно від категорії. */
export function defaultMaterialFormUnitForCategory(category) {
    const c = String(category || "").trim();
    if (c === "FABRIC") {
        return "м";
    }
    if (c === "PRINTS_EMBROIDERY") {
        return "шт";
    }
    return "шт";
}

/** Чи одиниця складу — кілограми (техкарта «пог. м → кг»). */
export function isMaterialUnitKg(raw) {
    return normalizeMaterialUnitToCode(raw) === "кг";
}
